import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

const DISMISS_KEY = "subBannerDismissed";

export function SubscriptionBanner() {
  const { user } = useAuth();
  const { lang } = useI18n();
  const loc = useLocation();
  const nav = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === "1");
  }, []);

  if (!user) return null;
  if (["/login", "/signup", "/account", "/payment/success", "/payment/cancel"].includes(loc.pathname)) return null;
  if (user.role === "admin") return null;
  if (user.subscription === "pro" || user.subscription === "unlimited" || dismissed) return null;

  const close = (e) => { e.stopPropagation(); localStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); };
  const go = () => nav("/account");

  return (
    <div
      data-testid="sub-banner"
      onClick={go}
      role="button"
      className="fixed left-3 right-3 z-[45] mx-auto max-w-2xl px-4 py-2.5 flex items-center gap-3 rounded-2xl cursor-pointer active:scale-[0.99] transition"
      style={{
        bottom: "calc(env(safe-area-inset-bottom) + 88px)",
        background: "linear-gradient(135deg, #f5b800 0%, #eab308 100%)",
        boxShadow: "0 8px 24px -8px rgba(245, 184, 0, 0.55)",
      }}
    >
      <Sparkles className="w-5 h-5 text-white shrink-0" />
      <p className="text-sm font-semibold text-white flex-1 leading-tight">
        {lang === "ar" ? "ترقّية إلى Pro — 2.99$ / شهر لميّزات أكثر" : "Upgrade to Pro — $2.99/mo for more features"}
      </p>
      <button
        data-testid="sub-banner-close"
        onClick={close}
        className="p-1 rounded-lg hover:bg-white/20 text-white"
        aria-label="dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
